module.exports = __webpack_public_path__ + "img/unlock-demo.7ef5108b.jpg";